import { AxiosInstance } from 'axios';

import { Refusal, RefusalPreset } from '../../../store/entities/refusals/refusals.types';
import { APIManagerConfig } from '../apiManager';
import { ReportFilterSettings } from '../../../store/entities/reports/reports.types';

const RefusalsServiceFactory = ({ HTTPBase, config }: { HTTPBase: AxiosInstance; config: APIManagerConfig }) => {
  return {
    getRefusals: (daysBack: number, endDate: Date, groupIds?: string, groupTypeIds?: string): Promise<Refusal[]> =>
      HTTPBase.get(`farm/${config.farmId}/refusals`, { params: { daysBack, endDate, groupIds, groupTypeIds } }).then(
        (res) => res.data,
      ),
    getReportFilterData: (): Promise<ReportFilterSettings> =>
      HTTPBase.get(`farm/${config.farmId}/refusals/filterData`).then((res) => res.data),
    getPresets: (): Promise<RefusalPreset[]> =>
      HTTPBase.get(`farm/${config.farmId}/refusals/presets`).then((res) => res.data),
  };
};

export default RefusalsServiceFactory;
